const WIDGET_PERIODICITY = Object.freeze({
  DAY: "DAY",
});

const WIDGET_REDIRECTION = Object.freeze({
  VEHICLE_LIST_USE: "VEHICLE_LIST_USE",
  VEHICLE_LIST_STOPPED: "VEHICLE_LIST_STOPPED",
  VEHICLE_LIST_BLOCKED: "VEHICLE_LIST_BLOCKED",
  VEHICLE_LIST_ALL: "VEHICLE_LIST_ALL",
  CONTRACTS_EXPIRE_TOMORROW: "CONTRACTS_EXPIRE_TOMORROW",
  CURRENT_CONTRACTS_DELAY: "CURRENT_CONTRACTS_DELAY",
  CONTRACTS_NO_VALID_USER: "CONTRACTS_NO_VALID_USER",
});

const WIDGET_INDICATORS = Object.freeze({
  BILLING_BY_TRAVEL: "BILLBYTRAV",
});

export default {
  WIDGET_PERIODICITY: WIDGET_PERIODICITY,
  WIDGET_REDIRECTION: WIDGET_REDIRECTION,
  WIDGET_INDICATORS: WIDGET_INDICATORS,
};
